import {getPublicProperty} from '@netx/core-app-next/utils/getPublicProperty';
import type {IGroupUser} from '@netx/core-system-groups/schema';
import {currentUserMeetsUserLevel, UserLevel} from '../utils';

export const canLoginAsUser = (user?: IGroupUser) =>
	// DAM-11575 loginAs fails with public user
	user != null &&
	currentUserMeetsUserLevel(UserLevel.ADMIN) &&
	getPublicProperty('viewer.userLogin') !== user.username;
